"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmVoucher
 * @author xlongjiang
 * @created 2025-11-13 10:40:06
 */

const TabPanel = _tpmProductIntl.Tab.TabPanel;
const Row = _tpmProductIntl.Grid.Row,
  Col = _tpmProductIntl.Grid.Col;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmVoucherData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? '' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$tabList = _ref.tabList,
    tabList = _ref$tabList === void 0 ? [] : _ref$tabList;
  const handleTabList = tabList.map((item, index) => {
    const _item$text = item.text,
      text = _item$text === void 0 ? '' : _item$text,
      _item$columns = item.columns,
      columns = _item$columns === void 0 ? 2 : _item$columns,
      _item$itemList = item.itemList,
      itemList = _item$itemList === void 0 ? [] : _item$itemList;
    const handleItemList = itemList.map((item, key) => {
      const _item$tag = item.tag,
        tag = _item$tag === void 0 ? '' : _item$tag,
        _item$title = item.title,
        title = _item$title === void 0 ? '' : _item$title,
        _item$features = item.features,
        features = _item$features === void 0 ? [] : _item$features,
        _item$text2 = item.text,
        text = _item$text2 === void 0 ? '' : _item$text2,
        _item$btnText = item.btnText,
        btnText = _item$btnText === void 0 ? '' : _item$btnText,
        _item$btnHref = item.btnHref,
        btnHref = _item$btnHref === void 0 ? '' : _item$btnHref;
      const handleBtn = () => {
        const btnExtendProps = {
          'report-event': 'click_Voucher_btn',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': btnText || '',
          target: '_blank'
        };
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          type: 'primary',
          href: btnHref,
          icon: true,
          align: 'center'
        }, btnExtendProps), btnText);
      };
      return {
        tag,
        title,
        features,
        text,
        btn: btnText && btnHref ? handleBtn() : null
      };
    });
    return {
      text,
      columns,
      itemList: handleItemList
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    tabList: handleTabList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmVoucherData = formatTpmVoucherData(data, {
        domains
      }),
      porintId = _formatTpmVoucherData.porintId,
      tag = _formatTpmVoucherData.tag,
      title = _formatTpmVoucherData.title,
      desc = _formatTpmVoucherData.desc,
      bg = _formatTpmVoucherData.bg,
      bgColor = _formatTpmVoucherData.bgColor,
      bgImg = _formatTpmVoucherData.bgImg,
      tabList = _formatTpmVoucherData.tabList;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmVoucher`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmVoucher', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, tabList.length > 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: tabList.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, tabList.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`,
      key: index
    }, /*#__PURE__*/React.createElement(Row, {
      gap: 20,
      gutter: {
        whole: 5,
        pad: 4,
        phone: 4
      }
    }, item.itemList.map((voucher, key) => /*#__PURE__*/React.createElement(Col, {
      span: 24 / item.columns,
      pad: 24,
      phone: 24,
      key: key
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Voucher, voucher))))))) : tabList.map((item, index) => /*#__PURE__*/React.createElement(Row, {
      gap: 20,
      gutter: {
        whole: 5,
        pad: 4,
        phone: 4
      },
      key: index
    }, item.itemList.map((voucher, key) => /*#__PURE__*/React.createElement(Col, {
      span: 24 / item.columns,
      pad: 24,
      phone: 24,
      key: key
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Voucher, voucher)))))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}